import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ToastIcon from "./ToastIcon";
import ToastCloseButton from "./ToastCloseButton";

// Custom toast content, rendered via react-toastify's "own component" API:
// https://fkhadra.github.io/react-toastify/use-your-own-component
// `data` and `toastProps` are injected by react-toastify. `data.description`
// is optional and renders the complementary info block below the main message.
const ToastMessage = ({ closeToast, data = {}, toastProps = {} }) => {
  const { message, description } = data;
  const { type } = toastProps;

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          p: "10px 12px",
        }}
      >
        <ToastIcon type={type} />
        <Typography
          sx={{
            flex: 1,
            fontFamily: "inherit",
            fontSize: 16,
            fontWeight: type === "warning" ? 700 : 400,
            color: type === "warning" ? "#000" : "inherit",
          }}
        >
          {message}
        </Typography>
        <ToastCloseButton closeToast={closeToast} type={type} />
      </Box>
      {description && (
        <Typography
          sx={{
            fontFamily: "inherit",
            fontSize: 14,
            color: "#3B3C3E",
            backgroundColor: "#FFFFFF",
            borderRadius: "0 0 8px 8px",
            padding: "12px",
            whiteSpace: "pre-line",
          }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default ToastMessage;
